import { useParams } from 'react-router';
import { StudentListDetailsComponent } from '../../parts/StudentRiskHistory/StudentListDetailsComponent';

export function StudentSessionDetailContainer() {
  const { id } = useParams<{ id: string }>();
  return (
    <StudentListDetailsComponent
      sessionEnrollmentId={id}
      origin="riskSession"
    />
  );
}
